import { HttpResponse } from '@angular/common/http';
import { InsuranceItem } from '../models/insurance-item.model';
import { inject, Injectable } from '@angular/core';
import { IBaryTableFetchService } from './i-bary-table-fetch-service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { ApiProviderService } from './api-provider.service';
import { Observable, of } from 'rxjs';
import { createRequestOption, mapAsBody } from '../app/shared/util/request-util';
import { InsuranceItemCategory } from '../models/insurance-item-view.model';
import { map } from 'rxjs/operators';

export type EntityResponseType = HttpResponse<InsuranceItem>;
export type EntityArrayResponseType = HttpResponse<InsuranceItemCategory[]>;

@Injectable({ providedIn: 'root' })
export class InsuranceItemCategoryService implements IBaryTableFetchService<InsuranceItemCategory> {
  readonly #apiProvider = inject(ApiProviderService);

  protected resourceUrl = API_ENDPOINTS.INSURANCE_ITEMS;

  public query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.#apiProvider.get<InsuranceItemCategory[]>(this.resourceUrl, options).pipe(
      map((res: EntityArrayResponseType) => {
        return new HttpResponse<InsuranceItemCategory[]>({
          body: (res.body || []).map(v => new InsuranceItemCategory(v)),
          status: res.status,
          headers: res.headers,
          url: res.url as string,
        });
      })
    );
  }

  public updateInsuranceItem(insuranceItemCategory: InsuranceItemCategory): Observable<InsuranceItemCategory> {
    return this.#apiProvider.put<InsuranceItemCategory>(`${this.resourceUrl}/update`, insuranceItemCategory.serialize()).pipe(mapAsBody);
  }

  // Utilisation de put car nécessite de passer un objet et non un Id comme d'habitude
  public delete(insuranceItemCategory: InsuranceItemCategory): Observable<InsuranceItemCategory> {
    return this.#apiProvider.put<InsuranceItemCategory>(`${this.resourceUrl}/delete`, insuranceItemCategory.serialize()).pipe(mapAsBody);
  }

  public fillDataToShow(entities: InsuranceItemCategory[]): Observable<InsuranceItemCategory[]> {
    return of(entities);
  }

  public save(insuranceItemCategory: InsuranceItemCategory): Observable<InsuranceItemCategory> {
    return this.#apiProvider.put<InsuranceItemCategory>(`${this.resourceUrl}`, insuranceItemCategory.serialize()).pipe(mapAsBody);
  }

  public create(insuranceItemCategory: InsuranceItemCategory): Observable<HttpResponse<InsuranceItemCategory>> {
    return this.#apiProvider.post<InsuranceItemCategory>(this.resourceUrl, insuranceItemCategory);
  }
}
